import React from "react";

const ModalContext = React.createContext<any>({});

ModalContext.displayName = "Modal Context";

export default ModalContext;
